import React from 'react'

const DownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='currenColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_11432_113730)'>
      <path
        d='M9.5 4.69824H7.5V1.69824H4.5V4.69824H2.5L6 8.19824L9.5 4.69824ZM2.5 9.19824V10.1982H9.5V9.19824H2.5Z'
        fill='currentcolor'
      />
    </g>
    <defs>
      <clipPath id='clip0_11432_113730'>
        <rect
          width='12'
          height='12'
          fill='white'
          transform='translate(0 0.198242)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default DownloadIcon
